import api from "./api";

const sources = new Map();

// Reutiliza consultas simultâneas; não conserva falhas como autorização.
export function getVideoSource(videoId) {
  if (!/^[a-zA-Z0-9_-]{11}$/.test(videoId || ""))
    return Promise.resolve({ ownership: "unverified" });
  const cached = sources.get(videoId);
  if (cached && cached.expiresAt > Date.now()) return cached.request;
  const entry = { expiresAt: Date.now() + 5 * 60 * 1000 };
  entry.request = api.get("/video-source", { params: { id: videoId }, timeout: 7000, headers: { "Cache-Control": "no-cache" } })
    .then(({ data }) => {
      const source = data?.data;
      if (!source || !["owned", "external", "unverified"].includes(source.ownership))
        throw new Error("Origem do vídeo indisponível.");
      entry.expiresAt = Date.now() + (source.ownership === "unverified" ? 30 * 1000 : 60 * 1000);
      return source;
    })
    .catch(() => {
      sources.delete(videoId);
      return { ownership: "unverified" };
    });
  sources.set(videoId, entry);
  return entry.request;
}

export async function saveVideoSource(videoId, settings) {
  const response = await api.put("/video-source", settings, { params: { id: videoId }, timeout: 10000 });
  sources.delete(videoId);
  return response.data.data;
}
